<div
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen$ | async"
  class="sidenav flex flex-col">
  <div class="sidenav-toolbar flex-none flex items-center">
    <img [src]="imageUrl$ | async" class="img-width select-none flex-none" alt="" />
    <img
      *ngIf="!collapsed"
      src="assets/img/logos/logo-text.png"
      alt="{{ 'SITE_NAME' | translate }}"
      class="logo-text select-none flex-none" />
    <!-- <h2 class="title ltr:pl-4 rtl:pr-4 select-none flex-auto">{{ title$ | async }}</h2> -->
    <button
      (click)="toggleCollapse()"
      *ngIf="showCollapsePin$ | async"
      class="w-8 h-8 -mr-2 leading-none flex-none hidden lg:block"
      mat-icon-button
      aria-label="fix menu"
      type="button">
      <mat-icon *ngIf="!collapsed" [icIcon]="icRadioButtonChecked" size="14px"></mat-icon>
      <mat-icon
        *ngIf="collapsed"
        [icIcon]="icRadioButtonUnchecked"
        size="14px"></mat-icon>
    </button>
  </div>

  <vex-scrollbar class="flex-auto">
    <div
      *ngIf="!collapsed"
      class="user-detail"
      fxLayout="column"
      fxLayoutAlign="center center">
      <h2 class="mt-4">{{ 'WELCOME' | translate }}</h2>
      <div fxLayoutAlign="center">
        <img
          class="logo-img"
          *ngIf="checkURL(profileImage)"
          [src]="loginUserData.Avatar"
          width="80"
          height="80"
          alt="" />
        <ngx-avatar
          *ngIf="!checkURL(profileImage)"
          [bgColor]="profileImage"
          fgColor="black"
          size="80"
          [name]="loginUserData.userName"
          value="75%"></ngx-avatar>
      </div>
      <h1 class="mt-2">{{ loginUserData.userName }}</h1>
      <!-- <span> {{ loginUserData.companyName }} </span> -->

      <div
        *ngIf="membershipUpgradeVisible"
        class="pt-4 w-full"
        fxLayout="row"
        fxLayoutAlign="start center">
        <div
          class="upgrade-section"
          fxFlex="100%"
          fxLayoutAlign="start center"
          (click)="upgradeMembership()">
          <div class="p-3 mx-4" fxFlex="70%">
            <h2>{{ 'UPGRADE_TO_PRO' | translate }}</h2>
            <h4 *ngIf="membershipName != 'Free'">{{ 'CURRENT_PLAN' | translate }}: {{ membershipName }}</h4>
            <p>{{ 'FOR_MORE_PROFILE_CONTROL' | translate }}</p>
          </div>
          <div fxLayout="row" fxFlex="30%" fxLayoutAlign="center end">
            <div class="crown-rect mr-2" fxLayoutAlign="center center">
              <img src="assets/img/icons/crown.png" width="35" height="24" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sidenav-items">
      <!-- <ng-container *ngFor="let item of items; trackBy: trackByRoute">
        <ng-container *ngIf="item.userRole === ''">
          <vex-sidenav-item [item]="item" [level]="0"></vex-sidenav-item>
        </ng-container>
      </ng-container> -->
      <!-- <vex-sidenav-item *ngFor="let item of items; trackBy: trackByRoute"
        [item]="item"
        [level]="0"></vex-sidenav-item> -->
      <!-- updated on 15 Feb, 2023 by Cai -->
      <ng-container *ngFor="let item of items; trackBy: trackByRoute">
        <vex-sidenav-item
          *ngIf="item.userRole.includes(loginUserData.role)"
          [item]="item"
          [level]="0"></vex-sidenav-item>
      </ng-container>
    </div>
  </vex-scrollbar>
</div>
